
	frappe.templates['form_links'] = `<div class="form-connections">
	{% for (let i=0; i < transactions.length; i++) { %}
		<div class="connection-group">
			{% if (transactions[i].label) { %}
			<div class="connection-group-label">{{ __(transactions[i].label) }}</div>
			{% } %}
			<div class="connection-group-items">
				{% for (let j=0; j < transactions[i].items.length; j++) { %}
					{% let doctype = transactions[i].items[j]; %}
					{% let fieldname = (transactions[i].fieldnames && transactions[i].fieldnames[doctype]) || transactions[i].fieldname; %}
					{% let sf = transactions[i].summary_fields && transactions[i].summary_fields[doctype]; %}
					<div class="connection-card" data-doctype="{{ doctype }}">
						<div class="connection-card-header">
							<div class="document-link-badge" data-doctype="{{ doctype }}" data-fieldname="{{ fieldname }}">
								<a class="badge-link">{{ __(doctype) }}</a>
							</div>
							{% if (!internal_links[doctype]) { %}
							<button class="btn btn-new btn-secondary btn-xs icon-btn hidden"
								data-doctype="{{ doctype }}"
								data-fieldname="{{ fieldname }}">
								<svg class="icon icon-sm"><use href="#icon-plus"></use></svg>
							</button>
							{% } %}
						</div>
						<div class="connection-card-stats hidden">
							<div class="connection-stat connection-stat-total">
								<div class="connection-stat-value count hidden">—</div>
								<div class="connection-stat-label">{{ __("Total") }}</div>
								{% if (sf) { %}
								<div class="connection-stat-summary summary-total hidden">
									<span class="summary-total-value"></span>
								</div>
								{% } %}
							</div>
							<div class="connection-stat connection-stat-open">
								<div class="connection-stat-value">
									<span class="open-notification"
										title="{{ __("Open {0}", [__(doctype)]) }}">—</span>
								</div>
								<div class="connection-stat-label">{{ __("Open") }}</div>
								{% if (sf && sf.open_field) { %}
								<div class="connection-stat-summary summary-open hidden">
									<span class="summary-open-value"></span>
								</div>
								{% } %}
							</div>
						</div>
					</div>
				{% } %}
			</div>
		</div>
	{% } %}
</div>
`;
